module.exports = __webpack_public_path__ + "static/gallery-8-cb03f9b94f2e73a2820dfce4085a8cfa.jpg";